<template>
  <div class="default-layout">
    <LeftAside />
    <NavHeader />
    <MainContainer>
      <slot></slot>
    </MainContainer>
    <Footer />
  </div>
</template>

<script lang="ts">
import LeftAside from "@/components/layout/LeftAside.vue"
import MainContainer from "@/components/layout/MainContainer.vue"
import NavHeader from "@/components/layout/NavHeader.vue"
import Footer from "@/components/layout/Footer.vue"
import { defineComponent } from "vue"
import { useLocalStorage } from "@vueuse/core"

export default defineComponent({
  components: {
    LeftAside,
    MainContainer,
    NavHeader,
    Footer,
  },
  setup() {
    const access_token = useLocalStorage("access_token", null)
    const refresh_token = useLocalStorage("refresh_token", null)
    const scope = useLocalStorage("scope", null)

    return { access_token, refresh_token, scope }
  },
  mounted() {
    if (this.access_token) {
      this.$store.dispatch("auth/setTokenData", {
        access_token: this.access_token,
        refresh_token: this.refresh_token,
        scope: this.scope,
      })
    }
  },
})
</script>
<style scoped>
.default-layout {
  background: #212429;
  min-height: 100vh;
}
</style>
